/*
 * Copyright (C) 2005 - 2025. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import 'jrs-ui/src/util/webpackPublicPathSetup';
const importStartup = import('jrs-ui/src/util/mainPagesStartup')
const importMain = () => import('./login.common');
const importCommonModule = () => import('jrs-ui/src/commons/commons.minimal.main')

importStartup.then(({default: startup}) => startup({
    importCommonModule,
    bundles: [
        "jasperserver_config",
        "jasperserver_messages",
        "jsexceptions_messages"
    ]
})).then(importMain)